var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-7"},[(!_vm.$store.getters['app/isQrMenu'])?_c('div',{staticClass:"mb-6"},[_c('OrderTypeButtons')],1):_vm._e(),_c('catalog-sections')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }